interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: "left" | "center";
  tone?: "primary" | "accent" | "secondary";
}

const toneChip: Record<string, string> = {
  primary: "bg-primary-100 text-primary-800 border-primary-200",
  accent: "bg-accent-100 text-accent-800 border-accent-200",
  secondary: "bg-secondary-100 text-secondary-900 border-secondary-200",
};

const toneBar: Record<string, string> = {
  primary: "bg-primary-500",
  accent: "bg-accent-500",
  secondary: "bg-secondary-500",
};

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "left",
  tone = "primary",
}: SectionHeadingProps) {
  const isCenter = align === "center";

  return (
    <div className={isCenter ? "flex flex-col items-center text-center" : ""}>
      {eyebrow && (
        <span
          className={`inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs font-medium tracking-wide ${toneChip[tone]}`}
        >
          <span className={`inline-flex h-1.5 w-4 rounded-full ${toneBar[tone]}`} />
          {eyebrow}
        </span>
      )}
      <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl lg:text-[2.1rem]">
        {title}
      </h2>
      {description && (
        <p
          className={`mt-3 text-sm leading-relaxed text-foreground-600 md:text-base ${
            isCenter ? "max-w-2xl" : "max-w-2xl"
          }`}
        >
          {description}
        </p>
      )}
    </div>
  );
}